import { useState } from "react";

const ARROW_ICON =
  "https://img.h4408b.com/hb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1788855333641";

export default function FooterDropdown() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="footer-collapse">
      <div className="footer-collapse__title">
        starbaji – Bangladesh’s Premier Online Casino &amp; Sports Betting Platform
      </div>

      <div
        className={
          isOpen
            ? "footer-collapse__content--active"
            : "footer-collapse__content"
        }
      >
        <div className="footer-description">
          <p>
            Welcome to starbaji, the number one online casino in Bangladesh, where you can enjoy the best online casino games and sports betting. Whether you are a fan of the roulette wheel or live sports, we have something special for you.
          </p>
          <br />
          <h5>Our Story</h5>
          <br />
          <p>
            starbaji online casino is an online betting platform in Bangladesh, where bettors can bet using the local currency. It was founded as a trusted online gaming platform that feels like home to every Bangladeshi player.
          </p>
          <p>Today, starbaji online casino is a household name in online gaming.</p>
          <br />
          <h5>Our Mission</h5>
          <br />
          <p>
            starbaji online casino betting has a simple mission. We aim to provide the most thrilling and safe gaming experience in Bangladesh. Every aspect of our platform has been created with you in mind. We listen to our gamers. We learn from them. And we continue to improve.
          </p>
          <p>
            Our founders saw a gap in the market. Players in Bangladesh deserved a world-class gaming experience. They deserved a platform that understood their needs. And that is exactly what we set out to build.
          </p>
          <p>
            We started small but dreamed big. Today, we have grown into a trusted name in online gaming. Thousands of players choose us every day. They come for the games. They stay for the experience. Our team is made up of gaming experts and tech specialists. We work together to bring you the best platform possible.
          </p>
          <br />
          <h5>Live Casino Experience</h5>
          <br />
          <p>
            Step into our live casino and feel the magic. Our professional live dealers are ready to welcome you. They bring the authentic casino atmosphere right to your screen. You can play from anywhere. Your living room becomes a VIP gaming lounge.
          </p>
          <p>
            We offer a stunning collection of classic casino games. Try your luck at Baccarat. Spin the wheel in Roulette. Experience the fast pace of Andar Bahar. Enjoy the ancient game of Fan Tan. Roll the dice in Sic Bo. Or battle it out in Dragon Tiger.
          </p>
          <p>
            Each game comes with crystal clear streaming. The graphics are sharp. The gameplay is smooth. You will feel like you are sitting at a real casino table. Our dealers are friendly and professional. They make every session memorable.
          </p>
          <br />
          <h5>Sports Betting Arena</h5>
          <br />
          <p>
            For sports fans, we have built something special. starbaji sportsbook covers all the major leagues and tournaments. Cricket, football, tennis, basketball. You name it, and we have it.
          </p>
          <p>
            Follow the action with live updates. Place your bets in real time. Watch the odds change as the game unfolds. Our platform gives you all the tools you need to make smart bets. Detailed statistics. Expert insights. Competitive odds.
          </p>
          <p>
            Whether it is the IPL or the World Cup, you will find the best betting options here. We cover local matches and international events. Every sports lover will find something to enjoy at starbaji online cricket betting platform.
          </p>
          <br />
          <h5>Rewards That Keep Coming</h5>
          <br />
          <p>
            At starbaji online casino, you're allowed to enjoy bonuses &amp; rewards to have extra money. With these rewards, you can enjoy a generous signup bonus with no deposit required. You can start playing without spending a single taka.
          </p>
          <p>
            For existing players, we offer unlimited cashback on your gaming activity. Regular promotions keep things exciting. Loyal players get special treatment. The more you play, the more you earn.
          </p>
          <br />
          <h5>Your Security Matters</h5>
          <br />
          <p>
            We take your safety seriously. Very seriously. starbaji online casino platform uses advanced encryption technology. Every transaction you make is protected. Your personal information stays private. We never share your data with anyone.
          </p>
          <p>
            We are licensed and regulated by the Curacao Gaming Commission. Our license number is GLH-OCCHKTW0712302019 with sub-license 365/JAZ.
          </p>
          <p>
            starbaji online casino operates under VB Digital N.V. Our headquarters are located at 9 Abraham de Veerstraat, Curacao. These credentials mean you are playing on a legitimate and trusted platform.
          </p>
          <p>In addition, we also adopt other security measures such as:</p>
          <br />
          <ul>
            <li>SSL military-grade encryption.</li>
            <li>KYC for withdrawals</li>
            <li>No data storage policy</li>
          </ul>
          <br />
          <p>
            All these security measures ensure that your personal and financial data is safe with us.
          </p>
          <br />
          <h5>Responsible Gaming</h5>
          <br />
          <p>
            Gaming should always be enjoyable. We promote responsible gaming at every step. Set your limits. Play within your means. If you ever feel like gaming is becoming a problem, reach out to us. We have tools and resources to help you stay in control.
          </p>
          <br />
          <h5>Support Available Around the Clock</h5>
          <br />
          <p>
            Have questions? Do you have concerns? Our customer support team is always there for you. We are available 24/7. Whenever you need assistance, we are only a message away. starbaji's online casino support team is friendly and knowledgeable. They will address your concerns in no time.
          </p>
          <br />
          <h5>Be Part of the starbaji Family</h5>
          <br />
          <p>
            We are more than just a gaming site. We are a community. A family of gamers who share the same passion. Every day, new members join us. It's your turn now.
          </p>
          <p>
            Join us today. Get your welcome bonus. Check out our games. Make your first bet. The fun is waiting for you.
          </p>
        </div>
      </div>

      <div
        className="footer-collapse__btn"
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen((prev) => !prev);
          }
        }}
      >
        {isOpen ? "Show Less" : "Show More"}
        <div
          className={
            isOpen
              ? "footer-collapse__btn-arrow--active"
              : "footer-collapse__btn-arrow"
          }
          style={{ maskImage: `url("${ARROW_ICON}")` }}
        />
      </div>
    </div>
  );
}